import { render, staticRenderFns } from "./big-tree.vue?vue&type=template&id=80d62488&"
import script from "./big-tree.vue?vue&type=script&lang=js&"
export * from "./big-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80d62488')) {
      api.createRecord('80d62488', component.options)
    } else {
      api.reload('80d62488', component.options)
    }
    module.hot.accept("./big-tree.vue?vue&type=template&id=80d62488&", function () {
      api.rerender('80d62488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tree/big-tree.vue"
export default component.exports